import PressableIcon from './PressableIcon'

export * from './PressableIcon'

export default PressableIcon
